import { render, staticRenderFns } from "./Rework.vue?vue&type=template&id=276566f6&v-slot%3Ano-data=true"
import script from "./Rework.vue?vue&type=script&lang=js"
export * from "./Rework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports